<script lang="ts">
import { getAutoDateFormatter } from '@/utils/date'

type Props = {
	date: string
}

let { date }: Props = $props()

let createdAtDate = $derived(new Date(date))

let formatter: Intl.DateTimeFormat = $derived(getAutoDateFormatter(createdAtDate))
</script>

{formatter.format(createdAtDate)}
